import { heroEntry } from '@/content/site';
import './LogoStrip.css';

export function LogoStrip() {
  return (
    <section className="logo-strip" aria-label={heroEntry.trustTitle}>
      <div className="container logo-strip__inner">
        <p className="logo-strip__title">{heroEntry.trustTitle}</p>
        <ul className="logo-strip__list">
          {heroEntry.trustLogos.map((logo) => (
            <li key={logo.name} className="logo-strip__item">
              <span className="logo-strip__badge">{logo.name}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
